(function (ws) {
    'use strict';

    ws.views.accountSearchResults = Backbone.View.extend({
        events: {
            'click tbody button[data-select-event]': 'selectAccount'
        },

        /**
         * Initializes the component.
         */
        initialize: function() {
            var html = '';
            var $headerRow = this.$('thead tr');
            var headers = $headerRow.data('headers');
            _.each(headers, function(header) {
                html += '<th>' + header + '</th>';
            });

            $headerRow.html(html);
        },

        /**
         * Triggers the account selection event.
         *
         * @param {Event} e
         */
        selectAccount: function(e) {
            var selectEvent = e.target.dataset.selectEvent;
            if (selectEvent) {
                this.eventAgg.trigger(selectEvent, {
                    address: JSON.parse(e.target.dataset.address)
                });
                $('.billto-address-invalid').hide();
            }
        }
    });
})(westcon);
